import { ErrorPage } from "@pages/misc/ErrorPage";

export function ErrorBoundary() {
  return <ErrorPage />;
}
